<template>
    <v-container>
        <div class="titulo my-4 px-4">
            <h1 class="font-weight-bold" :class="esMovil ? 'text-h6' : 'text-h5'">
                ¿Que es la Agencia Urbana?
            </h1>
        </div>
        <div>
            <v-img max-width="400" :src="imagen" class="float-md-left ma-3"> </v-img>

            <p class="texto">
                {{ texto }}
            </p>
        </div>
        <div>
            <v-img max-width="400" :src="imagen" class="float-md-end ma-3"> </v-img>

            <p class="texto">
                {{ texto }}
            </p>
        </div>
    </v-container>
</template>

<script>
import MasterdataService from "@services/MasterdataService";

export default {
    name: "Informacion",
    data: () => ({
        texto: "",
        imagen: "",
    }),
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    mounted() {
        MasterdataService.getInfomacion().then((response) => {
            this.texto = response.data.texto;
            this.imagen = response.data.imagen;
        });
    },
};
</script>
<style scoped></style>
